var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-12" },
    [
      _vm._l(_vm.visitDetailList, function(item) {
        return _c("div", { key: item.id }, [
          _c(
            "div",
            {
              staticClass: "row bg-white board-radius p-2",
              attrs: { id: "board" }
            },
            [
              _c(
                "section",
                {
                  staticClass: "col-md-3 border-right date-container",
                  class: {
                    "mb-4 flex justify-content-between": _vm.isMobile
                  }
                },
                [
                  _c("div", { staticClass: "w-100" }, [
                    _c(
                      "picture",
                      {
                        staticClass: "icon-container",
                        class: {
                          "ml-0": _vm.isMobile
                        }
                      },
                      [
                        _vm.isAbsence(item)
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/img/icon_square-x.svg")
                              }
                            })
                          : _vm.isCyberTeraphy(item)
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/img/icon_square-v.svg")
                              }
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/img/icon_square-p.svg")
                              }
                            })
                      ]
                    ),
                    _c("span", { staticClass: "font-weight-bold date" }, [
                      _vm._v(" " + _vm._s(_vm.formatDateLong(item)) + " ")
                    ])
                  ]),
                  _vm.isMobile && _vm.isAbsence(item)
                    ? _c("action-button", {
                        attrs: { i: "fas fa-edit", variant: "success mr-3" }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "section",
                {
                  staticClass: "col-md",
                  class: {
                    "border-top pt-3 mb-2": _vm.isMobile
                  }
                },
                [
                  _c(
                    "validation-observer",
                    { ref: _vm.editingFormRef(item), refInFor: true },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-3 content-container mb-2 mb-md-0"
                          },
                          [
                            _c("label", { staticClass: "data-name" }, [
                              _vm._v(" Tipos: ")
                            ]),
                            _c("br"),
                            _vm.editing(item)
                              ? _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-drop-down", {
                                              attrs: {
                                                "custom-error-msg":
                                                  "El tipo de ausencia es requerido.",
                                                error: errors[0],
                                                fieldkey: "id",
                                                fieldname: "name",
                                                options: _vm.visitTypeOptions,
                                                placeholder: "Seleccione"
                                              },
                                              model: {
                                                value: _vm.absenceModel.type,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.absenceModel,
                                                    "type",
                                                    $$v
                                                  )
                                                },
                                                expression: "absenceModel.type"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              : _c("span", { staticClass: "font-weight" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.visitName(item)) + " "
                                  )
                                ])
                          ],
                          1
                        ),
                        _vm.showJustified(item)
                          ? _c(
                              "div",
                              {
                                staticClass: "content-container mb-2 mb-md-0",
                                class: {
                                  "col-md-5": _vm.editing(item),
                                  "col-12 col-md": !_vm.editing(item)
                                }
                              },
                              [
                                _c("label", { staticClass: "data-name" }, [
                                  _vm._v(" Justificación: ")
                                ]),
                                _c("br"),
                                _vm.editing(item)
                                  ? _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-drop-down", {
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "La justificación es requerida.",
                                                    error: errors[0],
                                                    fieldkey: "id",
                                                    fieldname: "name",
                                                    options:
                                                      _vm.justificationOptions,
                                                    placeholder: "Seleccione"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.absenceModel
                                                        .justification,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.absenceModel,
                                                        "justification",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "absenceModel.justification"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  : _c("span", { staticClass: "font-weight" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item.modelAbsence?.justification
                                              ?.name
                                          ) +
                                          " "
                                      )
                                    ])
                              ],
                              1
                            )
                          : _vm.showDateReplacement(item) && !_vm.editing(item)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md content-container mb-2 mb-md-0"
                              },
                              [
                                _c("label", { staticClass: "data-name" }, [
                                  _vm._v(" Fecha a Reponer: ")
                                ]),
                                _c("br"),
                                _c("span", { staticClass: "font-weight" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatDate(item.dateToReplaceVisit)
                                      ) +
                                      " "
                                  )
                                ])
                              ]
                            )
                          : _vm.isAbsenceOfReplacementYear(item) &&
                            !_vm.editing(item)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md content-container mb-2 mb-md-0"
                              },
                              [
                                _c("label", { staticClass: "data-name" }, [
                                  _vm._v(" año anterior ")
                                ]),
                                _c("br"),
                                _c("span", { staticClass: "font-weight" }, [
                                  _vm._v(" " + _vm._s(item.lastYear) + " ")
                                ])
                              ]
                            )
                          : _c("div", {
                              staticClass: "col-md content-container"
                            }),
                        _vm.showDocument(item)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md content-container mb-2 mb-md-0",
                                class: { row: !_vm.editing(item) }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex w-100",
                                    class: _vm.isMobile && "ml-3"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "type-document",
                                        class: {
                                          "col-12": _vm.editing(item),
                                          "col-md-10":
                                            !_vm.editing(item) && !_vm.isMobile,
                                          "w-100": _vm.isMobile
                                        }
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "data-name" },
                                          [_vm._v("Tipo de Documento:")]
                                        ),
                                        _c("br"),
                                        _vm.showDocumentViewer(item)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center w-100 justify-content-start"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "mb-0 font-weight-normal"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.absenceModel
                                                            .document.name
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-row-reverse ml-2 button-container"
                                                  },
                                                  [
                                                    _c(
                                                      "action-button",
                                                      {
                                                        attrs: {
                                                          variant:
                                                            "outline-danger "
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.quitDocumentSelected
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-times-circle",
                                                          on: {
                                                            click:
                                                              _vm.quitDocumentSelected
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _c(
                                                      "action-button",
                                                      {
                                                        attrs: {
                                                          variant:
                                                            "outline-success mr-2"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.downloadDocument(
                                                              {
                                                                documentId:
                                                                  _vm
                                                                    .absenceModel
                                                                    .document.id
                                                              }
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-file-download"
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm.editing(item)
                                          ? _c("validation-provider", {
                                              attrs: { rules: "required" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c(
                                                          "custom-file-input",
                                                          {
                                                            ref:
                                                              "attachedDocument",
                                                            refInFor: true,
                                                            staticClass: "pr-3",
                                                            attrs: {
                                                              accept: ".pdf",
                                                              "custom-error-msg":
                                                                "El documento es requerido.",
                                                              "display-style":
                                                                "normal",
                                                              error: errors[0],
                                                              "label-position":
                                                                "left",
                                                              required: ""
                                                            },
                                                            on: {
                                                              "after-remove": () => {
                                                                _vm.absenceModel.file = null
                                                                _vm.absenceModel.documentId = null
                                                              },
                                                              input: () => {}
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.absenceModel
                                                                  .document,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.absenceModel,
                                                                  "document",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "absenceModel.document"
                                                            }
                                                          }
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : _c(
                                              "span",
                                              { staticClass: "font-weight" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.documentTypeName
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    ),
                                    item.documentId
                                      ? _c(
                                          "div",
                                          { staticClass: "px-0 col-sm-2 mt-2" },
                                          [
                                            _c("action-button", {
                                              staticClass: "icon-download",
                                              attrs: {
                                                i: "fas fa-file-download",
                                                variant: "success"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadDocument(
                                                    item
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.isAbsenceOfReplacementYear(item) &&
                        !_vm.editing(item)
                          ? _c(
                              "div",
                              { staticClass: "col-md content-container" },
                              [
                                _c("label", { staticClass: "data-name" }, [
                                  _vm._v("Solicitud:")
                                ]),
                                _c("br"),
                                _c("span", { staticClass: "font-weight" }, [
                                  _vm._v(" " + _vm._s(item.request) + " ")
                                ])
                              ]
                            )
                          : _vm._e(),
                        !_vm.isMobile && _vm.isAbsence(item)
                          ? _c(
                              "div",
                              { staticClass: "col-md-1 content-container" },
                              [
                                _c("action-button", {
                                  attrs: {
                                    i: "fas fa-edit",
                                    variant: "success float-right"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.ediVisit(item)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm.showComment(item)
                        ? _c(
                            "div",
                            { staticClass: "content-container mt-2" },
                            [
                              _c("label", { staticClass: "data-name" }, [
                                _vm._v("Comentario:")
                              ]),
                              _c("br"),
                              _vm.editing(item)
                                ? _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-input", {
                                                attrs: {
                                                  "custom-error-msg":
                                                    "El comentario es requerido.",
                                                  error: errors[0],
                                                  fieldkey: "id",
                                                  fieldname: "name",
                                                  maxlength: "3000",
                                                  placeholder:
                                                    "Escriba un comentario"
                                                },
                                                model: {
                                                  value:
                                                    _vm.absenceModel.comment,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.absenceModel,
                                                      "comment",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "absenceModel.comment"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                : _c("span", { staticClass: "font-weight" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.modelAbsence?.comment) +
                                        " "
                                    )
                                  ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.editing(item)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-end align-items-center my-3"
                            },
                            [
                              _c("action-button", {
                                attrs: {
                                  id: "btnCancel",
                                  i: "fas fa-times-circle",
                                  text: "Cancelar",
                                  variant: "outline-danger mr-3 px-3"
                                },
                                on: { click: _vm.disableEdit }
                              }),
                              _c("action-button", {
                                attrs: {
                                  id: "btnSave",
                                  i: "fas fa-save",
                                  text: "Guardar",
                                  variant: "success px-3"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveEdition(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._l(item.errors, function(error) {
                return _c(
                  "div",
                  { key: error.id, staticClass: "col-sm-12" },
                  [
                    _c("custom-error", {
                      staticClass: "visit-errors",
                      attrs: { message: error.message }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        ])
      }),
      _vm.studentAssistanceDetails.length == 0
        ? _c(
            "div",
            { staticClass: "bg-white board-radius p-2" },
            [_c("custom-result-not-found")],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }